import ButtonElement, { ButtonEvent } from "slotworks/graphics/elements/button-element";
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import currency from "slotworks/i18n/currency";
import Layers from "slotworks/graphics/layers/layers";
import BonusBuyContainer from "./bonus-buy-container";
import gameState from "slotworks/model/game-state";

export default class FSBuyPrompt {

    public buyButton: ButtonElement;
    public plusButton: ButtonElement;
    public minusButton: ButtonElement;

    public totalBetText: PIXI.Text;
    public totalValue: PIXI.BitmapText;

    private betOptions: BetOptions;

    private buy:Function;
    private increment: Function;
    private decrement: Function;

    constructor(betOptions: BetOptions, increment: Function, decrement: Function, buy: Function) {
        this.betOptions = betOptions;
        
        this.buy = buy;
        this.increment = increment;
        this.decrement = decrement;

        this.init();
    }

    public destroy() {
        this.buyButton.off(ButtonEvent.POINTER_DOWN, this.buy);
        this.minusButton.off(ButtonEvent.POINTER_DOWN, this.decrement);
        this.plusButton.off(ButtonEvent.POINTER_DOWN, this.increment);
    }

    public updateFields() {
        const currentBet = this.betOptions.getTotalStake();
        this.totalBetText.text = currency.format(currentBet);
        this.totalValue.text = currency.format(currentBet * BonusBuyContainer.MULTIPLIER_FREESPINS);

        if(this.isBalanceAboveAmount()) {
            this.buyButton.setEnabled(true);
        } else {
            this.buyButton.setEnabled(false);
        }
    }

    private isBalanceAboveAmount() {
        const currentBet = this.betOptions.getTotalStake();
        const amount = currentBet * BonusBuyContainer.MULTIPLIER_FREESPINS;
        const balance = gameState.getCurrentGame().balance;
        
        return amount <= balance;
    }

    private init() {
        this.buyButton = Layers.Custom.get("BonusBuyPopups").getButton("fsbuy");
        this.plusButton = Layers.Custom.get("BonusBuyPopups").getButton("fsnext");
        this.minusButton = Layers.Custom.get("BonusBuyPopups").getButton("fsprev");

        this.buyButton.on(ButtonEvent.POINTER_DOWN, this.buy);
        this.minusButton.on(ButtonEvent.POINTER_DOWN, this.decrement);
        this.plusButton.on(ButtonEvent.POINTER_DOWN, this.increment);

        this.totalBetText = Layers.Custom.get("BonusBuyPopups").getText("fsbet");
        this.totalValue = Layers.Custom.get("BonusBuyPopups").getBitmapText("fsvalue");
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/bonus-buy/fs-buy-prompt.ts